export const navItems = [
  { label: 'Início', href: '/' },
  { label: 'Estrutura', href: '/estrutura' },
  { label: 'Modalidades', href: '/modalidades' },
  { label: 'Horários', href: '/horarios' },
  { label: 'Localização', href: '/localizacao' },
  { label: 'Contato', href: '/contato' },
];

export const whatsappNumber = '5585982361153';
export const whatsappLink = `https://wa.me/${whatsappNumber}`;
export const email = 'topgymcumbuco@gmail.com';
export const instagram = 'https://www.instagram.com/topgymcumbuco/';
export const address = 'Av. Central, 2211 - Praia de Cumbuco, Caucaia - CE, 61619-270';
export const googleMapsLink = 'https://maps.google.com/?q=Av.+Central,+2211+-+Praia+de+Cumbuco,+Caucaia+-+CE,+61619-270';

export const gymInfo = {
  name: 'Top Gym Cumbuco',
  phone: '(85) 98236-1153',
  email: 'topgymcumbuco@gmail.com',
  address: 'Av. Central, 2211 - Praia de Cumbuco, Caucaia - CE, 61619-270',
  instagram: 'https://www.instagram.com/topgymcumbuco/',
  schedule: {
    weekday: 'Segunda a Sexta: 06h às 22h',
    saturday: 'Sábado: 08h às 12h',
    sunday: 'Domingo: Fechado',
  },
};